import { Annulation } from '../../annulation/models/Annulation';
import { AttributionFromFNSimple } from '../../attribution/models/AttributionFromFNSimple';
import { Initial } from '../../initial/models/Initial';
import { Rectificatif } from '../../rectificatif/models/Rectificatif';
import { TypeAdresseFNS } from './TypeAdresseFNS';

export class FNSimple {
	public annulationFromFNSimple: Annulation;

	public rectificatifFromFNSimple: Rectificatif;

	public initialFromFNSimple: Initial;

	public attribution: AttributionFromFNSimple;

	public organisme: TypeAdresseFNS;

	constructor() {
		this.annulationFromFNSimple = new Annulation();
		this.rectificatifFromFNSimple = new Rectificatif();
		this.initialFromFNSimple = new Initial();
		this.attribution = new AttributionFromFNSimple();
		this.organisme = new TypeAdresseFNS();
	}
}
